import React from "react";

interface IProps {
    forwardedRef: React.RefObject<HTMLDivElement | null>;
    primaryLinkRef: React.RefObject<HTMLAnchorElement | null>;
    tileUID: string | number;
    children?: React.ReactNode;
}

interface IState {}

// TODO(ssr, LEVEL 2 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 2/10 due to simple render-only component with image and text display logic.
export class GridTile extends React.Component<IProps, IState> {
    private readonly clickPrimaryLink = () => {
        if (this.props.primaryLinkRef.current) {
            this.props.primaryLinkRef.current.click();
        }
    };

    render() {
        return (
            <article
                ref={this.props.forwardedRef}
                className={`post al-tlovegrid-tile-${this.props.tileUID}`}
                role="group"
                aria-label="item"
            >
                <section
                    className="post__content"
                    onClick={this.clickPrimaryLink}
                >
                    {this.props.children}
                </section>
            </article>
        );
    }
}
